import { render, staticRenderFns } from "./ArticleOriginalFile.vue?vue&type=template&id=d91cbdd2&scoped=true&"
import script from "./ArticleOriginalFile.vue?vue&type=script&lang=js&"
export * from "./ArticleOriginalFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91cbdd2",
  null
  
)

export default component.exports